
  import {Vue, Component, Prop, Emit} from "vue-property-decorator"
  import {Scene} from '../interfaces/Interfaces'
  import {mapActions} from 'vuex'

  @Component({
    methods: {
      ...mapActions('scenes', {
        updateScene: 'updateScene'
      })
    },
  })
  export default class ScenesSelectionList extends Vue {

    @Prop() private scenes!: Scene[] | [] 
    @Prop() private videoLengthInDeciseconds!: number
    @Prop() private selectedSceneId: number | null = null
    @Prop() private lockedScenes!: number[] | []
    @Prop() private isSelectFrame!: boolean

    private editing: boolean = false
    private editingSceneId: number|null = null
    private editingSceneName: string = ""
    private alignTop: boolean = true
    private right: boolean = true

    private updateScene!: (updatedScene: Scene) => Scene

    private onUpdateScene(): void {
      const scene: Scene | undefined = this.scenes.find((s: Scene) => s.id === this.editingSceneId)
      if (scene && scene.label !== this.editingSceneName) {
        const updatedScene: Scene = {
          ...scene,
          label: this.editingSceneName
        }
        this.updateScene(updatedScene)
      }
      this.editing = false
      this.editingSceneId = null
      this.editingSceneName = ""
    }

    @Emit('setSelectedScene')
    private setSelectedScene(sceneId: number): number {
      this.editingSceneName = ""
      return sceneId
    }

    @Emit('toggleSelectFrame') public emitSelectFrame(sceneId: number) {
      return sceneId
    }
  }
